<nav class="bg-secondary h-18 flex items-center justify-end border-b-white border-b py-3 px-5">
  <app-user-header-info [currentUser]="activeUser$ | async"></app-user-header-info>
</nav>
